module.exports = __webpack_public_path__ + "img/isha.f0621815.png";